import { lazy } from "react"
import { CURRENCY } from "store/apis/balanceAPI/values"
import { UpgradeType } from "store/apis/upgradesAPI/types"

export const USER_MODALS = {
  upgrade: {},
  createDogName: {
    component: lazy(() => import("modals/ui/user/DogNameModal"))
  },
  changeDogName: {
    component: lazy(() => import("modals/ui/user/DogNameModal"))
  },
  leaderboardReward: {
    component: lazy(() => import("modals/ui/user/RewardModal"))
  },
  referral: {
    component: lazy(() => import("modals/ui/user/ReferralModal"))
  },
  referralRequired: {
    component: lazy(() => import("modals/ui/user/ReferralRequired"))
  },
  professionsGuide: {
    component: lazy(() => import("modals/ui/user/ProfessionsGuide"))
  },
  professionReset: {
    component: lazy(() => import("modals/ui/user/ProfessionReset")),
    params: {} as {
      name: string
      xpToReturn: number
      resetsNumber: number
    }
  },
  professionSkillInfo: {
    component: lazy(() => import("modals/ui/user/ProfessionSkillInfo")),
    params: {} as {
      name: string
      abilityEngName: string
      image: string
      description: string
      level: number
      bonus: number
      type: string
    }
  },
  dailyRewards: {
    component: lazy(() => import("modals/ui/user/DailyRewards"))
  },
  trainModal: {
    component: lazy(() => import("modals/ui/user/TrainingModal")),
    params: {} as {
      trainingType: UpgradeType
      levels: {
        goldLevel: number
        bonesLevel: number
      }
      currency: CURRENCY
      currValue: number
      upgradeValue: number
      price: number
      onSuccess: () => void
    }
  },
  merchant: {
    component: lazy(() => import("modals/ui/user/MerchantModal"))
  },
  changeEmail: {
    component: lazy(() => import("modals/ui/user/DogEmailModal")),
    params: {} as {
      isDetach: boolean
    }
  },
  emailVerifyAction: {
    component: lazy(() => import("modals/ui/user/EmailVerifyActionModal")),
    params: {} as {
      sentCode: () => any
      verifyCode: (code: string) => any
      successVerifyCode: (data: any) => void
    }
  },
  emailRequired: {
    component: lazy(() => import("modals/ui/user/EmailRequiredModal"))
  },
  jailCases: {
    component: lazy(() => import("modals/ui/user/JailCasesModal"))
  },
  goodBehavior: {
    component: lazy(() => import("modals/ui/user/GoodBehaviorModal"))
  }
} as const
